export type CreateObjectMappingCommand = {
    //iot edge device id
    deviceId: string,
    //iot edge module id
    moduleId: string,
    objectId: string,
    bacnetDeviceId: number,
    bacnetInstanceId: number,
    bacnetObjectType: number,
    resourceGroupId: string
}

export type BacnetObjectMappingConfiguration = {
    id: string,
    //iot edge device id
    deviceId: string,
    //iot edge module id
    moduleId: string,
    schema: string,
    objectId: string,
    bACnetDeviceId: number,
    objectMapping: BacnetObjectMapping,
    resourceGroupId: string
}

export type BacnetObjectMapping = {
    type: BacnetObjectTypes,
    instanceId: number
}


export type CreatePropertyMappingCommand = {
    //iot edge device id
    deviceId: string,
    //iot edge module id
    moduleId: string,
    bacnetDeviceId: number,
    bacnetInstanceId: number,
    bacnetObjectType: number,
    bacnetProperty :number, 
    objectId: string,
    propertyName: string,
    mapper?: Mapper,
    resourceGroupId: string
}
export type Mapper = {
    type: string,
    parameters: object
}

export type BacnetPropertyMappingConfiguration = {
    id: string,
    schema: string,
    deviceId: string,
    moduleId: string,
    objectId: string,
    propertyName: string,
    bacnetDeviceId: number,
    bacnetObjectType: BacnetObjectTypes,
    bacnetObjectInstanceId: number,
    bacnetPropertyType: BacnetPropertyIds,
    resourceGroupId: string
}

export type BacnetPropertyMapping = {
    type: BacnetObjectTypes,
    instanceId: number,
    propertyType: BacnetPropertyIds,
    propertyName: string,
}

export type BacnetObjectState = {
    objectType: BacnetObjectTypes,
    instanceId: number,
    bacnetDeviceId: number,
    objectName: string,
    objectDescription: string,
    presentValue?: any,
    presentValueTSource?: any
    unit?: number,
    moduleId: string,
    edgeDeviceId: string,
    selected: boolean, // internal for table selection
}
export type BacnetObjectPropertyState = {
    propertyType: BacnetPropertyIds,
    value: any,
    valueType: string,
    id: string
}

export type EdgeDeviceDto = {
    edgeDeviceId: string,
    bacnetDeviceCount: number,
}

export type EdgeBacnetDeviceDto = {
    edgeDeviceId: string,
    bacnetDeviceId: number,
}


export enum BacnetObjectTypes {
    ANALOG_INPUT = 0,
    ANALOG_OUTPUT = 1,
    ANALOG_VALUE = 2,
    BINARY_INPUT = 3,
    BINARY_OUTPUT = 4,
    BINARY_VALUE = 5,
    CALENDAR = 6,
    COMMAND = 7,
    DEVICE = 8,
    EVENT_ENROLLMENT = 9,
    FILE = 10,
    GROUP = 11,
    LOOP = 12,
    MULTI_STATE_INPUT = 13,
    MULTI_STATE_OUTPUT = 14,
    NOTIFICATION_CLASS = 15,
    PROGRAM = 16,
    SCHEDULE = 17,
    AVERAGING = 18,
    MULTI_STATE_VALUE = 19,
    TRENDLOG = 20,
    LIFE_SAFETY_POINT = 21,
    LIFE_SAFETY_ZONE = 22,
    ACCUMULATOR = 23,
    PULSE_CONVERTER = 24,
    EVENT_LOG = 25,
    GLOBAL_GROUP = 26,
    TREND_LOG_MULTIPLE = 27,
    LOAD_CONTROL = 28,
    STRUCTURED_VIEW = 29,
    ACCESS_DOOR = 30,
    TIMER = 31,                  /* Addendum 135-2012ay */
    ACCESS_CREDENTIAL = 32,      /* Addendum 2008-j */
    ACCESS_POINT = 33,
    ACCESS_RIGHTS = 34,
    ACCESS_USER = 35,
    ACCESS_ZONE = 36,
    CREDENTIAL_DATA_INPUT = 37,  /* authentication-factor-input */
    NETWORK_SECURITY = 38,       /* Addendum 2008-g */
    BITSTRING_VALUE = 39,        /* Addendum 2008-w */
    CHARACTERSTRING_VALUE = 40,  /* Addendum 2008-w */
    DATE_PATTERN_VALUE = 41,     /* Addendum 2008-w */
    DATE_VALUE = 42,             /* Addendum 2008-w */
    DATETIME_PATTERN_VALUE = 43, /* Addendum 2008-w */
    DATETIME_VALUE = 44,         /* Addendum 2008-w */
    INTEGER_VALUE = 45,          /* Addendum 2008-w */
    LARGE_ANALOG_VALUE = 46,     /* Addendum 2008-w */
    OCTETSTRING_VALUE = 47,      /* Addendum 2008-w */
    POSITIVE_INTEGER_VALUE = 48, /* Addendum 2008-w */
    TIME_PATTERN_VALUE = 49,     /* Addendum 2008-w */
    TIME_VALUE = 50,             /* Addendum 2008-w */
    NOTIFICATION_FORWARDER = 51, /* Addendum 2010-af */
    ALERT_ENROLLMENT = 52,       /* Addendum 2010-af */
    CHANNEL = 53,                /* Addendum 2010-aa */
    LIGHTING_OUTPUT = 54,        /* Addendum 2010-i */
    BINARY_LIGHTING_OUTPUT = 55, /* Addendum 135-2012az */

    /* Enumerated values 0-127 are reserved for definition by ASHRAE. */
    /* Enumerated values 128-1023 may be used by others subject to  */
    /* the procedures and constraints described in Clause 23. */
    /* do the max range inside of enum so that
       compilers will allocate adequate sized datatype for enum
       which is used to store decoding */

    PROPRIETARY_MIN = 128,
    PROPRIETARY_MAX = 1023,
    MAX_BACNET_TYPE = 1024,
    MAX_ASHRAE_TYPE = 56
}


export enum BacnetPropertyIds {
    ACKED_TRANSITIONS = 0,
    ACK_REQUIRED = 1,
    ACTION = 2,
    ACTION_TEXT = 3,
    ACTIVE_TEXT = 4,
    ACTIVE_VT_SESSIONS = 5,
    ALARM_VALUE = 6,
    ALARM_VALUES = 7,
    ALL = 8,
    ALL_WRITES_SUCCESSFUL = 9,
    APDU_SEGMENT_TIMEOUT = 10,
    APDU_TIMEOUT = 11,
    APPLICATION_SOFTWARE_VERSION = 12,
    ARCHIVE = 13,
    BIAS = 14,
    CHANGE_OF_STATE_COUNT = 15,
    CHANGE_OF_STATE_TIME = 16,
    NOTIFICATION_CLASS = 17,
    BLANK_1 = 18,
    CONTROLLED_VARIABLE_REFERENCE = 19,
    CONTROLLED_VARIABLE_UNITS = 20,
    CONTROLLED_VARIABLE_VALUE = 21,
    COV_INCREMENT = 22,
    DATE_LIST = 23,
    DAYLIGHT_SAVINGS_STATUS = 24,
    DEADBAND = 25,
    DERIVATIVE_CONSTANT = 26,
    DERIVATIVE_CONSTANT_UNITS = 27,
    DESCRIPTION = 28,
    DESCRIPTION_OF_HALT = 29,
    DEVICE_ADDRESS_BINDING = 30,
    DEVICE_TYPE = 31,
    EFFECTIVE_PERIOD = 32,
    ELAPSED_ACTIVE_TIME = 33,
    ERROR_LIMIT = 34,
    EVENT_ENABLE = 35,
    EVENT_STATE = 36,
    EVENT_TYPE = 37,
    EXCEPTION_SCHEDULE = 38,
    FAULT_VALUES = 39,
    FEEDBACK_VALUE = 40,
    FILE_ACCESS_METHOD = 41,
    FILE_SIZE = 42,
    FILE_TYPE = 43,
    FIRMWARE_REVISION = 44,
    HIGH_LIMIT = 45,
    INACTIVE_TEXT = 46,
    IN_PROCESS = 47,
    INSTANCE_OF = 48,
    INTEGRAL_CONSTANT = 49,
    INTEGRAL_CONSTANT_UNITS = 50,
    ISSUE_CONFIRMED_NOTIFICATIONS = 51,
    LIMIT_ENABLE = 52,
    LIST_OF_GROUP_MEMBERS = 53,
    LIST_OF_OBJECT_PROPERTY_REFERENCES = 54,
    LIST_OF_SESSION_KEYS = 55,
    LOCAL_DATE = 56,
    LOCAL_TIME = 57,
    LOCATION = 58,
    LOW_LIMIT = 59,
    MANIPULATED_VARIABLE_REFERENCE = 60,
    MAXIMUM_OUTPUT = 61,
    MAX_APDU_LENGTH_ACCEPTED = 62,
    MAX_INFO_FRAMES = 63,
    MAX_MASTER = 64,
    MAX_PRES_VALUE = 65,
    MINIMUM_OFF_TIME = 66,
    MINIMUM_ON_TIME = 67,
    MINIMUM_OUTPUT = 68,
    MIN_PRES_VALUE = 69,
    MODEL_NAME = 70,
    MODIFICATION_DATE = 71,
    NOTIFY_TYPE = 72,
    NUMBER_OF_APDU_RETRIES = 73,
    NUMBER_OF_STATES = 74,
    OBJECT_IDENTIFIER = 75,
    OBJECT_LIST = 76,
    OBJECT_NAME = 77,
    OBJECT_PROPERTY_REFERENCE = 78,
    OBJECT_TYPE = 79,
    OPTIONAL = 80,
    OUT_OF_SERVICE = 81,
    OUTPUT_UNITS = 82,
    EVENT_PARAMETERS = 83,
    POLARITY = 84,
    PRESENT_VALUE = 85,
    PRIORITY = 86,
    PRIORITY_ARRAY = 87,
    PRIORITY_FOR_WRITING = 88,
    PROCESS_IDENTIFIER = 89,
    PROGRAM_CHANGE = 90,
    PROGRAM_LOCATION = 91,
    PROGRAM_STATE = 92,
    PROPORTIONAL_CONSTANT = 93,
    PROPORTIONAL_CONSTANT_UNITS = 94,
    PROTOCOL_CONFORMANCE_CLASS = 95,       /* deleted in version 1 revision 2 */
    PROTOCOL_OBJECT_TYPES_SUPPORTED = 96,
    PROTOCOL_SERVICES_SUPPORTED = 97,
    PROTOCOL_VERSION = 98,
    READ_ONLY = 99,
    REASON_FOR_HALT = 100,
    RECIPIENT = 101,
    RECIPIENT_LIST = 102,
    RELIABILITY = 103,
    RELINQUISH_DEFAULT = 104,
    REQUIRED = 105,
    RESOLUTION = 106,
    SEGMENTATION_SUPPORTED = 107,
    SETPOINT = 108,
    SETPOINT_REFERENCE = 109,
    STATE_TEXT = 110,
    STATUS_FLAGS = 111,
    SYSTEM_STATUS = 112,
    TIME_DELAY = 113,
    TIME_OF_ACTIVE_TIME_RESET = 114,
    TIME_OF_STATE_COUNT_RESET = 115,
    TIME_SYNCHRONIZATION_RECIPIENTS = 116,
    UNITS = 117,
    UPDATE_INTERVAL = 118,
    UTC_OFFSET = 119,
    VENDOR_IDENTIFIER = 120,
    VENDOR_NAME = 121,
    VT_CLASSES_SUPPORTED = 122,
    WEEKLY_SCHEDULE = 123,
    ATTEMPTED_SAMPLES = 124,
    AVERAGE_VALUE = 125,
    BUFFER_SIZE = 126,
    CLIENT_COV_INCREMENT = 127,
    COV_RESUBSCRIPTION_INTERVAL = 128,
    CURRENT_NOTIFY_TIME = 129,
    EVENT_TIME_STAMPS = 130,
    LOG_BUFFER = 131,
    LOG_DEVICE_OBJECT_PROPERTY = 132,
    /* The enable property is renamed from log-enable in
       Addendum b to ANSI/ASHRAE 135-2004(135b-2) */
    ENABLE = 133,
    LOG_INTERVAL = 134,
    MAXIMUM_VALUE = 135,
    MINIMUM_VALUE = 136,
    NOTIFICATION_THRESHOLD = 137,
    PREVIOUS_NOTIFY_TIME = 138,
    PROTOCOL_REVISION = 139,
    RECORDS_SINCE_NOTIFICATION = 140,
    RECORD_COUNT = 141,
    START_TIME = 142,
    STOP_TIME = 143,
    STOP_WHEN_FULL = 144,
    TOTAL_RECORD_COUNT = 145,
    VALID_SAMPLES = 146,
    WINDOW_INTERVAL = 147,
    WINDOW_SAMPLES = 148,
    MAXIMUM_VALUE_TIMESTAMP = 149,
    MINIMUM_VALUE_TIMESTAMP = 150,
    VARIANCE_VALUE = 151,
    ACTIVE_COV_SUBSCRIPTIONS = 152,
    BACKUP_FAILURE_TIMEOUT = 153,
    CONFIGURATION_FILES = 154,
    DATABASE_REVISION = 155,
    DIRECT_READING = 156,
    LAST_RESTORE_TIME = 157,
    MAINTENANCE_REQUIRED = 158,
    MEMBER_OF = 159,
    MODE = 160,
    OPERATION_EXPECTED = 161,
    SETTING = 162,
    SILENCED = 163,
    TRACKING_VALUE = 164,
    ZONE_MEMBERS = 165,
    LIFE_SAFETY_ALARM_VALUES = 166,
    MAX_SEGMENTS_ACCEPTED = 167,
    PROFILE_NAME = 168,
    AUTO_SLAVE_DISCOVERY = 169,
    MANUAL_SLAVE_ADDRESS_BINDING = 170,
    SLAVE_ADDRESS_BINDING = 171,
    SLAVE_PROXY_ENABLE = 172,
    LAST_NOTIFY_RECORD = 173,
    SCHEDULE_DEFAULT = 174,
    ACCEPTED_MODES = 175,
    ADJUST_VALUE = 176,
    COUNT = 177,
    COUNT_BEFORE_CHANGE = 178,
    COUNT_CHANGE_TIME = 179,
    COV_PERIOD = 180,
    INPUT_REFERENCE = 181,
    LIMIT_MONITORING_INTERVAL = 182,
    LOGGING_OBJECT = 183,
    LOGGING_RECORD = 184,
    PRESCALE = 185,
    PULSE_RATE = 186,
    SCALE = 187,
    SCALE_FACTOR = 188,
    UPDATE_TIME = 189,
    VALUE_BEFORE_CHANGE = 190,
    VALUE_SET = 191,
    VALUE_CHANGE_TIME = 192,
    /* enumerations 193-206 are new */
    ALIGN_INTERVALS = 193,
    /* enumeration 194 is unassigned */
    INTERVAL_OFFSET = 195,
    LAST_RESTART_REASON = 196,
    LOGGING_TYPE = 197,
    /* enumeration 198-201 is unassigned */
    RESTART_NOTIFICATION_RECIPIENTS = 202,
    TIME_OF_DEVICE_RESTART = 203,
    TIME_SYNCHRONIZATION_INTERVAL = 204,
    TRIGGER = 205,
    UTC_TIME_SYNCHRONIZATION_RECIPIENTS = 206,
    /* enumerations 207-211 are used in Addendum d to ANSI/ASHRAE 135-2004 */
    NODE_SUBTYPE = 207,
    NODE_TYPE = 208,
    STRUCTURED_OBJECT_LIST = 209,
    SUBORDINATE_ANNOTATIONS = 210,
    SUBORDINATE_LIST = 211,
    /* enumerations 212-225 are used in Addendum e to ANSI/ASHRAE 135-2004 */
    ACTUAL_SHED_LEVEL = 212,
    DUTY_WINDOW = 213,
    EXPECTED_SHED_LEVEL = 214,
    FULL_DUTY_BASELINE = 215,
    /* enumerations 216-217 are unassigned */
    /* enumerations 212-225 are used in Addendum e to ANSI/ASHRAE 135-2004 */
    REQUESTED_SHED_LEVEL = 218,
    SHED_DURATION = 219,
    SHED_LEVEL_DESCRIPTIONS = 220,
    SHED_LEVELS = 221,
    STATE_DESCRIPTION = 222,
    /* enumerations 223-225 are unassigned  */
    /* enumerations 226-235 are used in Addendum f to ANSI/ASHRAE 135-2004 */
    DOOR_ALARM_STATE = 226,
    DOOR_EXTENDED_PULSE_TIME = 227,
    DOOR_MEMBERS = 228,
    DOOR_OPEN_TOO_LONG_TIME = 229,
    DOOR_PULSE_TIME = 230,
    DOOR_STATUS = 231,
    DOOR_UNLOCK_DELAY_TIME = 232,
    LOCK_STATUS = 233,
    MASKED_ALARM_VALUES = 234,
    SECURED_STATUS = 235,
    /* enumerations 236-243 are unassigned  */
    /* enumerations 244-311 are used in Addendum j to ANSI/ASHRAE 135-2004 */
    ABSENTEE_LIMIT = 244,
    ACCESS_ALARM_EVENTS = 245,
    ACCESS_DOORS = 246,
    ACCESS_EVENT = 247,
    ACCESS_EVENT_AUTHENTICATION_FACTOR = 248,
    ACCESS_EVENT_CREDENTIAL = 249,
    ACCESS_EVENT_TIME = 250,
    ACCESS_TRANSACTION_EVENTS = 251,
    ACCOMPANIMENT = 252,
    ACCOMPANIMENT_TIME = 253,
    ACTIVATION_TIME = 254,
    ACTIVE_AUTHENTICATION_POLICY = 255,
    ASSIGNED_ACCESS_RIGHTS = 256,
    AUTHENTICATION_FACTORS = 257,
    AUTHENTICATION_POLICY_LIST = 258,
    AUTHENTICATION_POLICY_NAMES = 259,
    AUTHENTICATION_STATUS = 260,
    AUTHORIZATION_MODE = 261,
    BELONGS_TO = 262,
    CREDENTIAL_DISABLE = 263,
    CREDENTIAL_STATUS = 264,
    CREDENTIALS = 265,
    CREDENTIALS_IN_ZONE = 266,
    DAYS_REMAINING = 267,
    ENTRY_POINTS = 268,
    EXIT_POINTS = 269,
    EXPIRY_TIME = 270,
    EXTENDED_TIME_ENABLE = 271,
    FAILED_ATTEMPT_EVENTS = 272,
    FAILED_ATTEMPTS = 273,
    FAILED_ATTEMPTS_TIME = 274,
    LAST_ACCESS_EVENT = 275,
    LAST_ACCESS_POINT = 276,
    LAST_CREDENTIAL_ADDED = 277,
    LAST_CREDENTIAL_ADDED_TIME = 278,
    LAST_CREDENTIAL_REMOVED = 279,
    LAST_CREDENTIAL_REMOVED_TIME = 280,
    LAST_USE_TIME = 281,
    LOCKOUT = 282,
    LOCKOUT_RELINQUISH_TIME = 283,
    MASTER_EXEMPTION = 284,
    MAX_FAILED_ATTEMPTS = 285,
    MEMBERS = 286,
    MUSTER_POINT = 287,
    NEGATIVE_ACCESS_RULES = 288,
    NUMBER_OF_AUTHENTICATION_POLICIES = 289,
    OCCUPANCY_COUNT = 290,
    OCCUPANCY_COUNT_ADJUST = 291,
    OCCUPANCY_COUNT_ENABLE = 292,
    OCCUPANCY_EXEMPTION = 293,
    OCCUPANCY_LOWER_LIMIT = 294,
    OCCUPANCY_LOWER_LIMIT_ENFORCED = 295,
    OCCUPANCY_STATE = 296,
    OCCUPANCY_UPPER_LIMIT = 297,
    OCCUPANCY_UPPER_LIMIT_ENFORCED = 298,
    PASSBACK_EXEMPTION = 299,
    PASSBACK_MODE = 300,
    PASSBACK_TIMEOUT = 301,
    POSITIVE_ACCESS_RULES = 302,
    REASON_FOR_DISABLE = 303,
    SUPPORTED_FORMATS = 304,
    SUPPORTED_FORMAT_CLASSES = 305,
    THREAT_AUTHORITY = 306,
    THREAT_LEVEL = 307,
    TRACE_FLAG = 308,
    TRANSACTION_NOTIFICATION_CLASS = 309,
    USER_EXTERNAL_IDENTIFIER = 310,
    USER_INFORMATION_REFERENCE = 311,
    /* enumerations 312-316 are unassigned */
    USER_NAME = 317,
    USER_TYPE = 318,
    USES_REMAINING = 319,
    ZONE_FROM = 320,
    ZONE_TO = 321,
    ACCESS_EVENT_TAG = 322,
    GLOBAL_IDENTIFIER = 323,
    /* enumerations 324-325 are unassigned */
    VERIFICATION_TIME = 326,
    BASE_DEVICE_SECURITY_POLICY = 327,
    DISTRIBUTION_KEY_REVISION = 328,
    DO_NOT_HIDE = 329,
    KEY_SETS = 330,
    LAST_KEY_SERVER = 331,
    NETWORK_ACCESS_SECURITY_POLICIES = 332,
    PACKET_REORDER_TIME = 333,
    SECURITY_PDU_TIMEOUT = 334,
    SECURITY_TIME_WINDOW = 335,
    SUPPORTED_SECURITY_ALGORITHM = 336,
    UPDATE_KEY_SET_TIMEOUT = 337,
    BACKUP_AND_RESTORE_STATE = 338,
    BACKUP_PREPARATION_TIME = 339,
    RESTORE_COMPLETION_TIME = 340,
    RESTORE_PREPARATION_TIME = 341,
    /* enumerations 342-344 are defined in Addendum 2008-w */
    BIT_MASK = 342,
    BIT_TEXT = 343,
    IS_UTC = 344,
    GROUP_MEMBERS = 345,
    GROUP_MEMBER_NAMES = 346,
    MEMBER_STATUS_FLAGS = 347,
    REQUESTED_UPDATE_INTERVAL = 348,
    COVU_PERIOD = 349,
    COVU_RECIPIENTS = 350,
    EVENT_MESSAGE_TEXTS = 351,
    /* enumerations 352-363 are defined in Addendum 2010-af */
    EVENT_MESSAGE_TEXTS_CONFIG = 352,
    EVENT_DETECTION_ENABLE = 353,
    EVENT_ALGORITHM_INHIBIT = 354,
    EVENT_ALGORITHM_INHIBIT_REF = 355,
    TIME_DELAY_NORMAL = 356,
    RELIABILITY_EVALUATION_INHIBIT = 357,
    FAULT_PARAMETERS = 358,
    FAULT_TYPE = 359,
    LOCAL_FORWARDING_ONLY = 360,
    PROCESS_IDENTIFIER_FILTER = 361,
    SUBSCRIBED_RECIPIENTS = 362,
    PORT_FILTER = 363,
    /* enumeration 364 is defined in Addendum 2010-ae */
    AUTHORIZATION_EXEMPTIONS = 364,
    /* enumerations 365-370 are defined in Addendum 2010-aa */
    ALLOW_GROUP_DELAY_INHIBIT = 365,
    CHANNEL_NUMBER = 366,
    CONTROL_GROUPS = 367,
    EXECUTION_DELAY = 368,
    LAST_PRIORITY = 369,
    WRITE_STATUS = 370,
    /* enumeration 371 is defined in Addendum 2010-ao */
    PROPERTY_LIST = 371,
    /* enumeration 372 is defined in Addendum 2010-ak */
    SERIAL_NUMBER = 372,
    /* enumerations 373-386 are defined in Addendum 2010-i */
    BLINK_WARN_ENABLE = 373,
    DEFAULT_FADE_TIME = 374,
    DEFAULT_RAMP_RATE = 375,
    DEFAULT_STEP_INCREMENT = 376,
    EGRESS_TIME = 377,
    IN_PROGRESS = 378,
    INSTANTANEOUS_POWER = 379,
    LIGHTING_COMMAND = 380,
    LIGHTING_COMMAND_DEFAULT_PRIORITY = 381,
    MAX_ACTUAL_VALUE = 382,
    MIN_ACTUAL_VALUE = 383,
    POWER = 384,
    TRANSITION = 385,
    EGRESS_ACTIVE = 386,
    INTERFACE_VALUE = 387,
    FAULT_HIGH_LIMIT = 388,
    FAULT_LOW_LIMIT = 389,
    LOW_DIFF_LIMIT = 390,
    /* enumerations 391-392 are defined in Addendum 135-2012az */
    STRIKE_COUNT = 391,
    TIME_OF_STRIKE_COUNT_RESET = 392,
    /* enumerations 393-398 are defined in Addendum 135-2012ay */
    DEFAULT_TIMEOUT = 393,
    INITIAL_TIMEOUT = 394,
    LAST_STATE_CHANGE = 395,
    STATE_CHANGE_VALUES = 396,
    TIMER_RUNNING = 397,
    TIMER_STATE = 398,

    // Addendum-135-2012as
    COMMAND_TIME_ARRAY = 430,
    CURRENT_COMMAND_PRIORITY = 431,
    LAST_COMMAND_TIME = 432,
    VALUE_SOURCE = 433,
    VALUE_SOURCE_ARRAY = 434,

    SIEMENS_PROPRIETARY_DESCR = 3121,

    /* The special property identifiers all, optional, and required  */
    /* are reserved for use in the ReadPropertyConditional and */
    /* ReadPropertyMultiple services or services not defined in this standard. */
    /* Enumerated values 0-511 are reserved for definition by ASHRAE.  */
    /* Enumerated values 512-4194303 may be used by others subject to the  */
    /* procedures and constraints described in Clause 23.  */
    /* do the max range inside of enum so that
       compilers will allocate adequate sized datatype for enum
       which is used to store decoding */
    MAX_BACNET_PROPERTY_ID = 4194303
}

export enum BacnetUnitsId {
    METERS_PER_SECOND_PER_SECOND = 166,
    /* Area */
    SQUARE_METERS = 0,
    SQUARE_CENTIMETERS = 116,
    SQUARE_FEET = 1,
    SQUARE_INCHES = 115,
    /* Currency */
    CURRENCY1 = 105,
    CURRENCY2 = 106,
    CURRENCY3 = 107,
    CURRENCY4 = 108,
    CURRENCY5 = 109,
    CURRENCY6 = 110,
    CURRENCY7 = 111,
    CURRENCY8 = 112,
    CURRENCY9 = 113,
    CURRENCY10 = 114,
    /* Electrical */
    MILLIAMPERES = 2,
    AMPERES = 3,
    AMPERES_PER_METER = 167,
    AMPERES_PER_SQUARE_METER = 168,
    AMPERE_SQUARE_METERS = 169,
    DECIBELS = 199,
    DECIBELS_MILLIVOLT = 200,
    DECIBELS_VOLT = 201,
    FARADS = 170,
    HENRYS = 171,
    OHMS = 4,
    OHM_METERS = 172,
    MILLIOHMS = 145,
    KILOHMS = 122,
    MEGOHMS = 123,
    MICROSIEMENS = 190,
    MILLISIEMENS = 202,
    SIEMENS = 173,        /* 1 mho equals 1 siemens */
    SIEMENS_PER_METER = 174,
    TESLAS = 175,
    VOLTS = 5,
    MILLIVOLTS = 124,
    KILOVOLTS = 6,
    MEGAVOLTS = 7,
    VOLT_AMPERES = 8,
    KILOVOLT_AMPERES = 9,
    MEGAVOLT_AMPERES = 10,
    VOLT_AMPERES_REACTIVE = 11,
    KILOVOLT_AMPERES_REACTIVE = 12,
    MEGAVOLT_AMPERES_REACTIVE = 13,
    VOLTS_PER_DEGREE_KELVIN = 176,
    VOLTS_PER_METER = 177,
    DEGREES_PHASE = 14,
    POWER_FACTOR = 15,
    WEBERS = 178,
    /* Energy */
    JOULES = 16,
    KILOJOULES = 17,
    KILOJOULES_PER_KILOGRAM = 125,
    MEGAJOULES = 126,
    WATT_HOURS = 18,
    KILOWATT_HOURS = 19,
    MEGAWATT_HOURS = 146,
    WATT_HOURS_REACTIVE = 203,
    KILOWATT_HOURS_REACTIVE = 204,
    MEGAWATT_HOURS_REACTIVE = 205,
    BTUS = 20,
    KILO_BTUS = 147,
    MEGA_BTUS = 148,
    THERMS = 21,
    TON_HOURS = 22,
    /* Enthalpy */
    JOULES_PER_KILOGRAM_DRY_AIR = 23,
    KILOJOULES_PER_KILOGRAM_DRY_AIR = 149,
    MEGAJOULES_PER_KILOGRAM_DRY_AIR = 150,
    BTUS_PER_POUND_DRY_AIR = 24,
    BTUS_PER_POUND = 117,
    /* Entropy */
    JOULES_PER_DEGREE_KELVIN = 127,
    KILOJOULES_PER_DEGREE_KELVIN = 151,
    MEGAJOULES_PER_DEGREE_KELVIN = 152,
    JOULES_PER_KILOGRAM_DEGREE_KELVIN = 128,
    /* Force */
    NEWTON = 153,
    /* Frequency */
    CYCLES_PER_HOUR = 25,
    CYCLES_PER_MINUTE = 26,
    HERTZ = 27,
    KILOHERTZ = 129,
    MEGAHERTZ = 130,
    PER_HOUR = 131,
    /* Humidity */
    GRAMS_OF_WATER_PER_KILOGRAM_DRY_AIR = 28,
    PERCENT_RELATIVE_HUMIDITY = 29,
    /* Length */
    MICROMETERS = 194,
    MILLIMETERS = 30,
    CENTIMETERS = 118,
    KILOMETERS = 193,
    METERS = 31,
    INCHES = 32,
    FEET = 33,
    /* Light */
    CANDELAS = 179,
    CANDELAS_PER_SQUARE_METER = 180,
    WATTS_PER_SQUARE_FOOT = 34,
    WATTS_PER_SQUARE_METER = 35,
    LUMENS = 36,
    LUXES = 37,
    FOOT_CANDLES = 38,
    /* Mass */
    MILLIGRAMS = 196,
    GRAMS = 195,
    KILOGRAMS = 39,
    POUNDS_MASS = 40,
    TONS = 41,
    /* Mass Flow */
    GRAMS_PER_SECOND = 154,
    GRAMS_PER_MINUTE = 155,
    KILOGRAMS_PER_SECOND = 42,
    KILOGRAMS_PER_MINUTE = 43,
    KILOGRAMS_PER_HOUR = 44,
    POUNDS_MASS_PER_SECOND = 119,
    POUNDS_MASS_PER_MINUTE = 45,
    POUNDS_MASS_PER_HOUR = 46,
    TONS_PER_HOUR = 156,
    /* Power */
    MILLIWATTS = 132,
    WATTS = 47,
    KILOWATTS = 48,
    MEGAWATTS = 49,
    BTUS_PER_HOUR = 50,
    KILO_BTUS_PER_HOUR = 157,
    HORSEPOWER = 51,
    TONS_REFRIGERATION = 52,
    /* Pressure */
    PASCALS = 53,
    HECTOPASCALS = 133,
    KILOPASCALS = 54,
    MILLIBARS = 134,
    BARS = 55,
    POUNDS_FORCE_PER_SQUARE_INCH = 56,
    MILLIMETERS_OF_WATER = 206,
    CENTIMETERS_OF_WATER = 57,
    INCHES_OF_WATER = 58,
    MILLIMETERS_OF_MERCURY = 59,
    CENTIMETERS_OF_MERCURY = 60,
    INCHES_OF_MERCURY = 61,
    /* Temperature */
    DEGREES_CELSIUS = 62,
    DEGREES_KELVIN = 63,
    DEGREES_KELVIN_PER_HOUR = 181,
    DEGREES_KELVIN_PER_MINUTE = 182,
    DEGREES_FAHRENHEIT = 64,
    DEGREE_DAYS_CELSIUS = 65,
    DEGREE_DAYS_FAHRENHEIT = 66,
    DELTA_DEGREES_FAHRENHEIT = 120,
    DELTA_DEGREES_KELVIN = 121,
    /* Time */
    YEARS = 67,
    MONTHS = 68,
    WEEKS = 69,
    DAYS = 70,
    HOURS = 71,
    MINUTES = 72,
    SECONDS = 73,
    HUNDREDTHS_SECONDS = 158,
    MILLISECONDS = 159,
    /* Torque */
    NEWTON_METERS = 160,
    /* Velocity */
    MILLIMETERS_PER_SECOND = 161,
    MILLIMETERS_PER_MINUTE = 162,
    METERS_PER_SECOND = 74,
    METERS_PER_MINUTE = 163,
    METERS_PER_HOUR = 164,
    KILOMETERS_PER_HOUR = 75,
    FEET_PER_SECOND = 76,
    FEET_PER_MINUTE = 77,
    MILES_PER_HOUR = 78,
    /* Volume */
    CUBIC_FEET = 79,
    CUBIC_METERS = 80,
    IMPERIAL_GALLONS = 81,
    MILLILITERS = 197,
    LITERS = 82,
    US_GALLONS = 83,
    /* Volumetric Flow */
    CUBIC_FEET_PER_SECOND = 142,
    CUBIC_FEET_PER_MINUTE = 84,
    // One unit in Addendum 135-2012bg
    MILLION_CUBIC_FEET_PER_MINUTE = 254,
    CUBIC_FEET_PER_HOUR = 191,
    // five units in Addendum 135-2012bg
    STANDARD_CUBIC_FEET_PER_DAY = 47808,
    MILLION_STANDARD_CUBIC_FEET_PER_DAY = 47809,
    THOUSAND_CUBIC_FEET_PER_DAY = 47810,
    THOUSAND_STANDARD_CUBIC_FEET_PER_DAY = 47811,
    UINITS_POUNDS_MASS_PER_DAY = 47812,
    CUBIC_METERS_PER_SECOND = 85,
    CUBIC_METERS_PER_MINUTE = 165,
    CUBIC_METERS_PER_HOUR = 135,
    IMPERIAL_GALLONS_PER_MINUTE = 86,
    MILLILITERS_PER_SECOND = 198,
    LITERS_PER_SECOND = 87,
    LITERS_PER_MINUTE = 88,
    LITERS_PER_HOUR = 136,
    US_GALLONS_PER_MINUTE = 89,
    US_GALLONS_PER_HOUR = 192,
    /* Other */
    DEGREES_ANGULAR = 90,
    DEGREES_CELSIUS_PER_HOUR = 91,
    DEGREES_CELSIUS_PER_MINUTE = 92,
    DEGREES_FAHRENHEIT_PER_HOUR = 93,
    DEGREES_FAHRENHEIT_PER_MINUTE = 94,
    JOULE_SECONDS = 183,
    KILOGRAMS_PER_CUBIC_METER = 186,
    KW_HOURS_PER_SQUARE_METER = 137,
    KW_HOURS_PER_SQUARE_FOOT = 138,
    MEGAJOULES_PER_SQUARE_METER = 139,
    MEGAJOULES_PER_SQUARE_FOOT = 140,
    NO_UNITS = 95,
    NEWTON_SECONDS = 187,
    NEWTONS_PER_METER = 188,
    PARTS_PER_MILLION = 96,
    PARTS_PER_BILLION = 97,
    PERCENT = 98,
    PERCENT_OBSCURATION_PER_FOOT = 143,
    PERCENT_OBSCURATION_PER_METER = 144,
    PERCENT_PER_SECOND = 99,
    PER_MINUTE = 100,
    PER_SECOND = 101,
    PSI_PER_DEGREE_FAHRENHEIT = 102,
    RADIANS = 103,
    RADIANS_PER_SECOND = 184,
    REVOLUTIONS_PER_MINUTE = 104,
    SQUARE_METERS_PER_NEWTON = 185,
    WATTS_PER_METER_PER_DEGREE_KELVIN = 189,
    WATTS_PER_SQUARE_METER_DEGREE_KELVIN = 141,
    PER_MILLE = 207,
    GRAMS_PER_GRAM = 208,
    KILOGRAMS_PER_KILOGRAM = 209,
    GRAMS_PER_KILOGRAM = 210,
    MILLIGRAMS_PER_GRAM = 211,
    MILLIGRAMS_PER_KILOGRAM = 212,
    GRAMS_PER_MILLILITER = 213,
    GRAMS_PER_LITER = 214,
    MILLIGRAMS_PER_LITER = 215,
    MICROGRAMS_PER_LITER = 216,
    GRAMS_PER_CUBIC_METER = 217,
    MILLIGRAMS_PER_CUBIC_METER = 218,
    MICROGRAMS_PER_CUBIC_METER = 219,
    NANOGRAMS_PER_CUBIC_METER = 220,
    GRAMS_PER_CUBIC_CENTIMETER = 221,
    BECQUERELS = 222,
    KILOBECQUERELS = 223,
    MEGABECQUERELS = 224,
    GRAY = 225,
    MILLIGRAY = 226,
    MICROGRAY = 227,
    SIEVERTS = 228,
    MILLISIEVERTS = 229,
    MICROSIEVERTS = 230,
    MICROSIEVERTS_PER_HOUR = 231,
    DECIBELS_A = 232,
    NEPHELOMETRIC_TURBIDITY_UNIT = 233,
    PH = 234,
    GRAMS_PER_SQUARE_METER = 235,
    // Since Addendum 135-2012ar
    MINUTES_PER_DEGREE_KELVIN = 236,
    METER_SQUARED_PER_METER = 237,
    AMPERE_SECONDS = 238,
    VOLT_AMPERE_HOURS = 239,
    KILOVOLT_AMPERE_HOURS = 240,
    MEGAVOLT_AMPERE_HOURS = 241,
    VOLT_AMPERE_HOURS_REACTIVE = 242,
    KILOVOLT_AMPERE_HOURS_REACTIVE = 243,
    MEGAVOLT_AMPERE_HOURS_REACTIVE = 244,
    VOLT_SQUARE_HOURS = 245,
    AMPERE_SQUARE_HOURS = 246,
    JOULE_PER_HOURS = 247,
    CUBIC_FEET_PER_DAY = 248,
    CUBIC_METERS_PER_DAY = 249,
    WATT_HOURS_PER_CUBIC_METER = 250,
    JOULES_PER_CUBIC_METER = 251,
    MOLE_PERCENT = 252,
    PASCAL_SECONDS = 253,
    MILLION_STANDARD_CUBIC_FEET_PER_MINUTE = 254
}


export enum BACnetVendorId {
    ANY = -1,
    ASHRAE = 0,
    NIST = 1,
    TheTraneCompany = 2,
    McQuayInternational = 3,
    PolarSoft = 4,
    JohnsonControlsInc = 5,
    AmericanAuto_Matrix = 6,
    SiemensSchweizAG_Formerly_Landis_StaefaDivisionEurope = 7,
    DeltaControls = 8,
    SiemensSchweizAG = 9,
    SchneiderElectric = 335,
    TAC = 11,
    OrionAnalysisCorporation = 12,
    TeletrolSystemsInc = 13,
    CimetricsTechnology = 14,
    CornellUniversity = 0xF,
    UnitedTechnologiesCarrier = 0x10,
    HoneywellInc = 17,
    Alerton_Honeywell = 18,
    TACAB = 19,
    Hewlett_PackardCompany = 20,
    DorsettesInc = 21,
    SiemensSchweizAG_Formerly_CerberusAG = 22,
    YorkControlsGroup = 23,
    AutomatedLogicCorporation = 24,
    CSIControlSystemsInternational = 25,
    PhoenixControlsCorporation = 26,
    InnovexTechnologiesInc = 27,
    KMCControlsInc = 28,
    XnTechnologiesInc = 29,
    HyundaiInformationTechnologyCoLtd = 30,
    TokimecInc = 0x1F,
    Simplex = 0x20,
    NorthBuildingTechnologiesLimited = 33,
    Notifier = 34,
    ReliableControlsCorporation = 35,
    TridiumInc = 36,
    SierraMonitorCorporation_FieldServerTechnologies = 37,
    SiliconEnergy = 38,
    Kieback_PeterGmbH_CoKG = 39,
    AnaconSystemsInc = 40,
    SystemsControls_InstrumentsLLC = 41,
    LithoniaLighting = 42,
    MicropowerManufacturing = 43,
    MatrixControls = 44,
    METALAIRE = 45,
    ESSEngineering = 46,
    SphereSystemsPtyLtd = 47,
    WalkerTechnologiesCorporation = 48,
    HISolutionsInc = 49,
    MBSGmbH = 50,
    SAMSONAG = 51,
    BadgerMeterInc = 52,
    DAIKINIndustriesLtd = 53,
    NARAControlsInc = 54,
    MammothInc = 55,
    LiebertCorporation = 56,
    SEMCOIncorporated = 57,
    AirMonitorCorporation = 510,
    TRIATEKLLC = 59,
    NexLight = 60,
    Multistack = 61,
    TSIIncorporated = 62,
    Weather_RiteInc = 0x3F,
    Dunham_Bush = 0x40,
    RelianceElectric = 65,
    LCSInc = 66,
    RegulatorAustraliaPTYLtd = 67,
    Touch_PlateLightingControls = 68,
    AmannGmbH = 69,
    RLETechnologies = 70,
    CardkeySystems = 71,
    SECOMCoLtd = 72,
    ABBGebaeudetechnikAGBereichNetServ = 73,
    KNXAssociationcvba = 74,
    InstituteofElectricalInstallationEngineersofJapan_IEIEJ = 75,
    NohmiBosaiLtd = 76,
    CarelSpA = 77,
    AirSenseTechnologyInc = 78,
    HochikiCorporation = 79,
    FrSauterAG = 80,
    MatsushitaElectricWorksLtd = 81,
    MitsubishiElectricCorporationInazawaWorks = 82,
    MitsubishiHeavyIndustriesLtd = 83,
    ITTBell_Gossett = 84,
    YamatakeBuildingSystemsCoLtd = 85,
    TheWattStopperInc = 86,
    AichiTokeiDenkiCoLtd = 87,
    ActivationTechnologiesLLC = 88,
    Saia_BurgessControlsLtd = 89,
    HitachiLtd = 474,
    NovarCorp_TrendControlSystemsLtd = 91,
    MitsubishiElectricLightingCorporation = 92,
    ArgusControlSystemsLtd = 93,
    KyukiCorporation = 94,
    Richards_ZetaBuildingIntelligenceInc = 95,
    ScientechR_DInc = 96,
    VCIControlsInc = 97,
    ToshibaCorporation = 98,
    MitsubishiElectricCorporationAirConditioning_RefrigerationSystemsWorks = 99,
    CustomMechanicalEquipmentLLC = 100,
    ClimateMaster = 101,
    ICPPanel_TecInc = 102,
    D_TekControls = 103,
    NECEngineeringLtd = 104,
    PRIVABV = 105,
    MeidenshaCorporation = 106,
    JCISystemsIntegrationServices = 107,
    FreedomCorporation = 108,
    NeubergerGebaeudeautomationGmbH = 109,
    Sitronix = 110,
    LevitonManufacturing = 111,
    FujitsuLimited = 112,
    EmersonNetworkPower = 113,
    SAArmstrongLtd = 114,
    VisonetAG = 115,
    M_MSystemsInc = 116,
    CustomSoftwareEngineering = 117,
    NittanCompanyLimited = 118,
    ElutionsInc_WizconSystemsSAS = 119,
    PacomSystemsPtyLtd = 120,
    UnicoInc = 121,
    EbtronInc = 122,
    ScadaEngine = 123,
    ACTechnologyCorporation = 124,
    EagleTechnology = 125,
    DataAireInc = 126,
    ABBInc = 0x7F,
    TransbitSpzoo = 0x80,
    ToshibaCarrierCorporation = 129,
    ShenzhenJunzhiHi_TechCoLtd = 130,
    TokaiSoft = 131,
    BlueRidgeTechnologies = 132,
    VerisIndustries = 133,
    CentaurusPrime = 134,
    SandNetworkSystems = 135,
    RegulvarInc = 136,
    AFDtekDivisionofFastekInternationalInc = 137,
    PowerColdComfortAirSolutionsInc = 138,
    IControls = 139,
    ViconicsElectronicsInc = 140,
    YaskawaAmericaInc = 141,
    DEOScontrolsystemsGmbH = 142,
    DigitaleMess_undSteuersystemeAG = 143,
    FujitsuGeneralLimited = 144,
    ProjectEngineeringSrl = 145,
    SanyoElectricCoLtd = 146,
    IntegratedInformationSystemsInc = 147,
    TemcoControlsLtd = 148,
    AirtekInternationalInc = 149,
    AdvantechCorporation = 150,
    TitanProductsLtd = 151,
    RegelPartners = 152,
    NationalEnvironmentalProduct = 153,
    UnitecCorporation = 154,
    KandenEngineeringCompany = 155,
    MessnerGebaeudetechnikGmbH = 156,
    IntegratedCH = 157,
    PriceIndustries = 158,
    SE_ElektronicGmbH = 159,
    RockwellAutomation = 160,
    EnflexCorp = 161,
    ASIControls = 162,
    SysMikGmbHDresden = 163,
    HSCRegelungstechnikGmbH = 164,
    SmartTempAustraliaPtyLtd = 165,
    CooperControls = 166,
    DuksanMecasysCoLtd = 167,
    FujiITCoLtd = 168,
    VaconPlc = 169,
    LeaderControls = 170,
    CylonControlsLtd = 171,
    Compas = 172,
    MitsubishiElectricBuildingTechno_ServiceCoLtd = 173,
    BuildingControlIntegrators = 174,
    ITGWorldwide_MSdnBhd = 175,
    LutronElectronicsCoInc = 176,
    LOYTECElectronicsGmbH = 178,
    ProLon = 179,
    MegaControlsLimited = 180,
    MicroControlSystemsInc = 181,
    KiyonInc = 182,
    DustNetworks = 183,
    AdvancedBuildingAutomationSystems = 184,
    HermosAG = 185,
    CEZIM = 186,
    Softing = 187,
    Lynxspring = 188,
    SchneiderToshibaInverterEurope = 189,
    DanfossDrivesA_S = 190,
    EatonCorporation = 191,
    MatycaSA = 192,
    BotechAB = 193,
    NoveoInc = 194,
    AMEV = 195,
    YokogawaElectricCorporation = 196,
    GFRGesellschaft = 197,
    ExactLogic = 198,
    MassElectronicsPtyLtddbaInnotechControlSystemsAustralia = 199,
    KandenkoCoLtd = 200,
    DTFDaten_TechnikFries = 201,
    KlimasoftLtd = 202,
    ToshibaSchneiderInverterCorporation = 203,
    ControlApplicationsLtd = 204,
    KDTSystemsCoLtd = 205,
    OniconIncorporated = 206,
    AutomationDisplaysInc = 207,
    ControlSolutionsInc = 208,
    RemsdaqLimited = 209,
    NTTFacilitiesInc = 210,
    VIPAGmbH = 211,
    TSC21AssociationofJapan = 212,
    StratoAutomation = 213,
    HRWLimited = 214,
    LightingControl_DesignInc = 215,
    MercyElectronicandElectricalIndustries = 216,
    SamsungSDSCoLtd = 217,
    ImpactFacilitySolutionsInc = 218,
    Aircuity = 219,
    ControlTechniquesLtd = 220,
    OpenGeneralPtyLtd = 221,
    WAGOKontakttechnikGmbH_CoKG = 222,
    CerusIndustrial = 223,
    ChloridePowerProtectionCompany = 224,
    ComputrolsInc = 225,
    PhoenixContactGmbH_CoKG = 226,
    GrundfosManagementA_S = 227,
    RidderDriveSystems = 228,
    SoftDeviceSDNBHD = 229,
    IntegratedControlTechnologyLimited = 230,
    AIRxpertSystemsInc = 231,
    MicrotrolLimited = 232,
    RedLionControls = 233,
    DigitalElectronicsCorporation = 234,
    EnnovatisGmbH = 235,
    SerotoninSoftwareTechnologiesInc = 236,
    LSIndustrialSystemsCoLtd = 237,
    SquareDCompany = 238,
    SSquaredInnovationsInc = 239,
    AricentLtd = 240,
    EtherMetricsLLC = 241,
    IndustrialControlCommunicationsInc = 242,
    ParagonControlsInc = 243,
    AOSmithCorporation = 244,
    ContemporaryControlSystemsInc = 245,
    IntesisSoftwareSL = 246,
    IngenieurgesellschaftNHartlebmbH = 247,
    Heat_TimerCorporation = 248,
    IngrasysTechnologyInc = 249,
    CostermBuildingAutomation = 250,
    WILOSE = 251,
    EmbediaTechnologiesCorp = 252,
    Technilog = 253,
    HRControlsLtd_CoKG = 254,
    LennoxInternationalInc = 0xFF,
    RK_TecRauchklappen_SteuerungssystemeGmbH_CoKG = 0x100,
    ThermomaxLtd = 257,
    ELCONElectronicControlLtd = 258,
    LarmiaControlAB = 259,
    BACnetStackatSourceForge = 260,
    G4SSecurityServicesA_S = 261,
    ExorInternationalSpA = 262,
    CristalControles = 263,
    ReginAB = 264,
    DimensionSoftwareInc = 265,
    SynapSenseCorporation = 266,
    BeijingNantreeElectronicCoLtd = 267,
    CamusHydronicsLtd = 268,
    KawasakiHeavyIndustriesLtd = 269,
    CriticalEnvironmentTechnologies = 270,
    ILSHINIBSCoLtd = 271,
    ELESTAEnergyControlAG = 272,
    KROPMANInstallatietechniek = 273,
    BaldorElectricCompany = 274,
    INGAmbH = 275,
    GEConsumer_Industrial = 276,
    FunctionalDevicesInc = 277,
    ESAC = 278,
    M_SystemCoLtd = 279,
    YokotaCoLtd = 280,
    HitranseTechnologyCoLTD = 281,
    FederspielControls = 282,
    KeleInc = 283,
    OperaElectronicsInc = 284,
    Gentec = 285,
    EmbeddedScienceLabsLLC = 286,
    ParkerHannifinCorporation = 287,
    MaCaPSInternationalLimited = 288,
    Link4Corporation = 289,
    RomutecSteuer_uRegelsystemeGmbH = 290,
    PribusinInc = 291,
    AdvantageControls = 292,
    CriticalRoomControl = 293,
    LEGRAND = 294,
    TongdyControlTechnologyCoLtd = 295,
    ISSAROIntegrierteSystemtechnik = 296,
    Pro_DevIndustries = 297,
    DRI_STEEM = 298,
    CreativeElectronicGmbH = 299,
    SwegonAB = 300,
    JanBrachacek = 301,
    HitachiAppliancesInc = 302,
    RealTimeAutomationInc = 303,
    ITECHankyu_HanshinCo = 304,
    CyrusE_MEngineeringCoLtd = 305,
    RacineFederatedInc = 306,
    CirrascaleCorporation = 307,
    ElestaGmbHBuildingAutomation = 308,
    Securiton = 309,
    OSlsoftInc = 310,
    HanazederElectronicGmbH = 311,
    HoneywellSecurityDeutschlandNovarGmbH = 312,
    SiemensEnergy_AutomationInc = 313,
    ETMProfessionalControlGmbH = 314,
    Meitav_tecLtd = 315,
    JanitzaElectronicsGmbH = 316,
    MKSNordhausen = 317,
    DeGierDriveSystemsBV = 318,
    CypressEnvirosystems = 319,
    SMARTronsro = 320,
    VerariSystemsInc = 321,
    K_WElectronicServiceInc = 322,
    ALFA_SMARTEnergyManagement = 323,
    TelkonetInc = 324,
    SecuritonGmbH = 325,
    CemtrexInc = 326,
    PerformanceTechnologiesInc = 327,
    Xtralis_AustPtyLtd = 328,
    TROXGmbH = 329,
    BeijingHysineTechnologyCoLtd = 330,
    RCKControlsInc = 331,
    DistechControlsSAS = 332,
    Novar_Honeywell = 333,
    TheS4GroupInc = 334,
    __SchneiderElectric = 335,
    LHASystems = 336,
    GHMengineeringGroupInc = 337,
    CllimaluxSA = 338,
    VAISALAOyj = 339,
    COMPLEX_BeijingTechnologyCoLtd = 340,
    SCADAmetrics = 341,
    POWERPEGNSILimited = 342,
    BACnetInteroperabilityTestingServicesInc = 343,
    Tecoas = 344,
    PlexusTechnologyInc = 345,
    EnergyFocusInc = 346,
    PowersmithsInternationalCorp = 347,
    NichibeiCoLtd = 348,
    HKCTechnologyLtd = 349,
    OvationNetworksInc = 350,
    SetraSystems = 351,
    AVGAutomation = 352,
    ZXCLtd = 353,
    ByteSphere = 354,
    GeneritonCoLtd = 355,
    HolterRegelarmaturenGmbH_CoKG = 356,
    BedfordInstrumentsLLC = 357,
    StandairInc = 358,
    WEGAutomation_R_D = 359,
    ProlonControlSystemsApS = 360,
    Inneasoft = 361,
    ConneXSoftGmbH = 362,
    CEAGNotlichtsystemeGmbH = 363,
    DistechControlsInc = 364,
    IndustrialTechnologyResearchInstitute = 365,
    ICONICSInc = 366,
    IQControlssc = 367,
    OJElectronicsA_S = 368,
    RolbitLtd = 369,
    SynapsysSolutionsLtd = 370,
    ACMEEngineeringProdLtd = 371,
    ZenerElectricPtyLtd = 372,
    SelectronixInc = 373,
    Gorbet_BanerjeeLLC = 374,
    IME = 375,
    StephenHDawsonComputerService = 376,
    AccutrolLLC = 377,
    SchneiderElektronikGmbH = 378,
    Alpha_InnoTecGmbH = 379,
    ADMMicroInc = 380,
    GreystoneEnergySystemsInc = 381,
    CAPTechnologie = 382,
    KeRoSystems = 383,
    DomatControlSystemsro = 384,
    EfektronicsPtyLtd = 385,
    HekatronVertriebsGmbH = 386,
    SecuritonAG = 387,
    CarloGavazziControlsSpA = 388,
    ChipkinAutomationSystems = 389,
    SavantSystemsLLC = 390,
    SimmtronicLightingControls = 391,
    AbelkoInnovationAB = 392,
    SerescoTechnologiesInc = 393,
    ITWatchdogs = 394,
    AutomationAssistJapanCorp = 395,
    ThermokonSensortechnikGmbH = 396,
    EGaugeSystemsLLC = 397,
    QuantumAutomation_ASIAPTELtd = 398,
    ToshibaLighting_TechnologyCorp = 399,
    SPINEngenhariadeAutomaLtda = 400,
    LogisticsSystems_SoftwareServicesIndiaPVTLtd = 401,
    DeltaControlsIntegrationProducts = 402,
    FocusMedia = 403,
    LUMEnergiInc = 404,
    KaraSystems = 405,
    RFCodeInc = 406,
    FatekAutomationCorp = 407,
    JANDASoftwareCompanyLLC = 408,
    OpenSystemSolutionsLimited = 409,
    IntelecSystemsPTYLtd = 410,
    EcolodgixLLC = 411,
    DouglasLightingControls = 412,
    iSAtechGmbH = 413,
    AREAL = 414,
    BeckhoffAutomationGmbH = 415,
    IPASGmbH = 416,
    KE2ThermSolutions = 417,
    Base2Products = 418,
    DTLControlsLLC = 419,
    INNCOMInternationalInc = 420,
    BTRNetcomGmbH = 421,
    GreentrolAutomationInc = 422,
    BELIMOAutomationAG = 423,
    SamsungHeavyIndustriesCoLtd = 424,
    TriactaPowerTechnologiesInc = 425,
    GlobestarSystems = 426,
    MLBAdvancedMediaLP = 427,
    SWGStuckmannWirtschaftlicheGebaeudesystemeGmbH = 428,
    SensorSwitch = 429,
    MultitekPowerLimited = 430,
    AquametroAG = 431,
    LGElectronicsInc = 432,
    ElectronicTheatreControlsInc = 433,
    MitsubishiElectricCorporationNagoyaWorks = 434,
    DeltaElectronicsInc = 435,
    ElmaKurtaljLtd = 436,
    ADTFireandSecuritySpAoo = 437,
    NedapSecurityManagement = 438,
    ESCAutomationInc = 439,
    DSP4YOULtd = 440,
    GESensingandInspectionTechnologies = 441,
    EmbeddedSystemsSIA = 442,
    BEFEGAGmbH = 443,
    BaselineInc = 444,
    M2MSystemsIntegrators = 445,
    OEMCtrl = 446,
    ClarksonControlsLimited = 447,
    RogerwellControlSystemLimited = 448,
    SCLElements = 449,
    __HitachiLtd = 450,
    NewronSystemSA = 451,
    BEVECOGebouwautomatiseringBV = 452,
    StreamsideSolutions = 453,
    YellowstoneSoft = 454,
    OztechIntelligentSystemsPtyLtd = 455,
    NovelanGmbH = 456,
    FleximAmericasCorporation = 457,
    ICPDASCoLtd = 458,
    CARMAIndustriesInc = 459,
    Log_OneLtd = 460,
    TECOElectric_MachineryCoLtd = 461,
    ConnectExInc = 462,
    TurboDDCS = 463,
    QuatrosenseEnvironmentalLtd = 464,
    FifthLightTechnologyLtd = 465,
    ScientificSolutionsLtd = 466,
    ControllerAreaNetworkSolutions_MSdnBhd = 467,
    RESOL_ElektronischeRegelungenGmbH = 468,
    RPBUSLLC = 469,
    BRSSistemasEletronicos = 470,
    WindowMasterA_S = 471,
    SunluxTechnologiesLtd = 472,
    Measurlogic = 473,
    FrimatGmbH = 474,
    SpiraxSarco = 475,
    Luxtron = 476,
    RaypakInc = 477,
    __AirMonitorCorporation = 478,
    ReglerOchWebbteknikSverige_ROWS = 479,
    IntelligentLightingControlsInc = 480,
    SanyoElectricIndustryCoLtd = 481,
    E_MonEnergyMonitoringProducts = 482,
    DigitalControlSystems = 483,
    ATIAirtestTechnologiesInc = 484,
    SCSSA = 485,
    HMSIndustrialNetworksAB = 486,
    ShenzhenUniversalIntellisysCoLtd = 487,
    EKIntellisysSdnBhd = 488,
    SysCom = 489,
    FirecomInc = 490,
    ESAElektroschaltanlagenGrimmaGmbH = 491,
    KumahiraCoLtd = 492,
    Hotraco = 493,
    SABOElektronikGmbH = 494,
    EquipTrans = 495,
    TCSBasysControls = 496,
    FlowConInternationalA_S = 497,
    ThyssenKruppElevatorAmericas = 498,
    AbatementTechnologies = 499,
    ContinentalControlSystemsLLC = 500,
    WISAGAutomatisierungstechnikGmbH_CoKG = 501,
    EasyIO = 502,
    EAP_ElectricGmbH = 503,
    Hardmeier = 504,
    MircomGroupofCompanies = 505,
    QuestControls = 506,
    MestekInc = 507,
    PulseEnergy = 508,
    TachikawaCorporation = 509,
    UniversityofNebraska_Lincoln = 510,
    RedwoodSystems = 0x1FF,
    PASStecIndustrie_ElektronikGmbH = 0x200,
    NgEKInc = 513,
    FAWElectronicsLtd = 514,
    JirehEnergyTechCoLtd = 515,
    EnlightedInc = 516,
    El_PiastSpZoo = 517,
    NetxAutomationSoftwareGmbH = 518,
    InvertekDrives = 519,
    DeutschmannAutomationGmbH_CoKG = 520,
    EMUElectronicAG = 521,
    PhaedrusLimited = 522,
    SigmatekGmbH_CoKG = 523,
    MarlinControls = 524,
    CircutorSA = 525,
    UTCFire_Security = 526,
    DENTInstrumentsInc = 527,
    FHPManufacturingCompany_BoschGroup = 528,
    GEIntelligentPlatforms = 529,
    InnerRangePtyLtd = 530,
    GLASEnergyTechnology = 531,
    MSR_Electronic_GmbH = 532,
    EnergyControlSystemsInc = 533,
    EMTControls = 534,
    DaintreeNetworksInc = 535,
    EUROICCdoo = 536,
    TEConnectivityEnergy = 537,
    GEZEGmbH = 538,
    NECCorporation = 539,
    HoCheungInternationalCompanyLimited = 540,
    SharpManufacturingSystemsCorporation = 541,
    DOTCONTROLSas = 542,
    BeaconMed_0220 = 543,
    MideaCommercialAircon = 544,
    WattMasterControls = 545,
    KamstrupA_S = 546,
    CAComputerAutomationGmbH = 547,
    LaarsHeatingSystemsCompany = 548,
    HitachiSystemsLtd = 549,
    FushanAKEElectronicEngineeringCoLtd = 550,
    ToshibaInternationalCorporation = 551,
    StarmanSystemsLLC = 552,
    SamsungTechwinCoLtd = 553,
    ISAS_IntegratedSwitchgearandSystemsP_L = 554,
    Obvius = 556,
    MarekGuzik = 557,
    VortekInstrumentsLLC = 558,
    UniversalLightingTechnologies = 559,
    MyersPowerProductsInc = 560,
    VectorControlsGmbH = 561,
    CrestronElectronicsInc = 562,
    A_EControlsLimited = 563,
    ProjektomontazaAD = 564,
    FreeaireRefrigeration = 565,
    AquaCoolerPtyLimited = 566,
    BasicControls = 567,
    GEMeasurementandControlSolutionsAdvancedSensors = 568,
    EQUALNetworks = 569,
    MillennialNet = 570,
    APLILtd = 571,
    ElectroIndustries_GaugeTech = 572,
    SangMyungUniversity = 573,
    CoppertreeAnalyticsInc = 574,
    CoreNetiXGmbH = 575,
    Acutherm = 576,
    DrRiedelAutomatisierungstechnikGmbH = 577,
    ShinaSystemCoLtd = 578,
    Iqapertus = 579,
    PSETechnology = 580,
    BASystems = 581,
    BTICINO = 582,
    MonicoInc = 583,
    iCue = 584,
    tekmarControlSystemsLtd = 585,
    ControlTechnologyCorporation = 586,
    GFAEGmbH = 587,
    BeKaSoftwareGmbH = 588,
    IsoilIndustriaSpA = 589,
    HomeSystemsConsultingSpA = 590,
    Socomec = 591,
    EverexCommunicationsInc = 592,
    CeiecElectricTechnology = 593,
    AtrilaGmbH = 594,
    WingTechs = 595,
    ShenzhenMekIntellisysPteLtd = 596,
    NestfieldCoLtd = 597,
    SwissphoneTelecomAG = 598,
    PNTECHJSC = 599,
    HornerAPGLLC = 600,
    PVIIndustriesLLC = 601,
    Ela_compil = 602,
    PegasusAutomationInternationalLLC = 603,
    WightElectronicServicesLtd = 604,
    Marcom = 605,
    ExhaustoA_S = 606,
    DwyerInstrumentsInc = 607,
    LinkGmbH = 608,
    OppermannRegelgerateGmbH = 609,
    NuAireInc = 610,
    NortecHumidityInc = 611,
    BigwoodSystemsInc = 612,
    EnbalaPowerNetworks = 613,
    InterEnergyCoLtd = 614,
    ETC = 615,
    COMELECSARL = 616,
    PythiaTechnologies = 617,
    TrendPointSystemsInc = 618,
    AWEX = 619,
    Eurevia = 620,
    KongsbergE_lonAS = 621,
    FlaktWoods = 622,
    E_EElektronikGESMBH = 623,
    ARCInformatique = 624,
    SKIDATAAG = 625,
    WSWSolutions = 626,
    TrefonElectronicGmbH = 627,
    DongseoSystem = 628,
    KanontecIntelligenceTechnologyCoLtd = 629,
    EVCOSpA = 630,
    Accuenergy_CANADAInc = 631,
    SoftDEL = 632,
    OrionEnergySystemsInc = 633,
    Roboticsware = 634,
    DOMIQSpzoo = 635,
    Solidyne = 636,
    ElecsysCorporation = 637,
    ConditionaireInternationalPtyLimited = 638,
    QuebecInc = 639,
    HomerunHoldings = 640,
    RFMInc = 641,
    Comptek = 642,
    WestcoSystemsInc = 643,
    AdvancisSoftware_ServicesGmbH = 644,
    IntergridLLC = 645,
    MarkerrControlsInc = 646,
    ToshibaElevatorandBuildingSystemsCorporation = 647,
    SpectrumControlsInc = 648,
    Mkservice = 649,
    FoxThermalInstruments = 650,
    SyxthSenseLtd = 651,
    DUHASystemSRO = 652,
    NIBE = 653,
    MelinkCorporation = 654,
    Fritz_Haber_Institut = 655,
    MTUOnsiteEnergyGmbHGasPowerSystems = 656,
    OmegaEngineeringInc = 657,
    Avelon = 658,
    YwireTechnologiesInc = 659,
    MREngineeringCoLtd = 660,
    LochinvarLLC = 661,
    SontayLimited = 662,
    GRUPASlawomirChelminski = 663,
    ArchMeterCorporation = 664,
    SenvaInc = 665,
    FM_Tec = 667,
    SystemsSpecialistsInc = 668,
    SenseAir = 669,
    ABIndustrieTechnikSrl = 670,
    CortlandResearchLLC = 671,
    MediaView = 672,
    VDAElettronica = 673,
    CSSInc = 674,
    Tek_AirSystemsInc = 675,
    ICDT = 676,
    TheArmstrongMonitoringCorporation = 677,
    DIXELLSrl = 678,
    LeadSystemInc = 679,
    ISMEuroCenterSA = 680,
    TDIS = 681,
    TradeFIDES = 682,
    KnuerrGmbH_EmersonNetworkPower = 683,
    ResourceDataManagement = 684,
    AbiesTechnologyInc = 685,
    Amalva = 686,
    MIRAEElectricalMfgCoLtd = 687,
    HunterDouglasArchitecturalProjectsScandinaviaApS = 688,
    RUNPAQGroupCoLtd = 689,
    UnicardSA = 690,
    IETechnologies = 691,
    RuskinManufacturing = 692,
    CalonAssociatesLimited = 693,
    ContecCoLtd = 694,
    iTGmbH = 695,
    AutaniCorporation = 696,
    ChristianFortin = 697,
    HDL = 698,
    IPIDSpZOOLimited = 699,
    FujiElectricCoLtd = 700,
    ViewInc = 701,
    SamsungS1Corporation = 702,
    NewLift = 703,
    VRTSystems = 704,
    MotionControlEngineeringInc = 705,
    WeissKlimatechnikGmbH = 706,
    Elkon = 707,
    EliwellControlsSrl = 708,
    JapanComputerTechnosCorp = 709,
    RationalNetworkehf = 710,
    MagnumEnergySolutionsLLC = 711,
    MelRok = 712,
    VAEGroup = 713,
    LGCNS = 714,
    BerghofAutomationstechnikGmbH = 715,
    QuarkCommunicationsInc = 716,
    Sontex = 717,
    mivuneAG = 718,
    Panduit = 719,
    SmartControlsLLC = 720,
    Compu_AireInc = 721,
    Sierra = 722,
    ProtoSenseTechnologies = 723,
    EltracTechnologiesPvtLtd = 724,
    BektasInvisibleControlsGmbH = 725,
    Entelec = 726,
    Innexiv = 727,
    Covenant = 728,
    evon = 793
}


export enum BacnetReliability {
    NoFaultDetected = 0, //The present value is reliable; that is, no other fault has been detected.
    NoSensor = 1, //No sensor is connected to the Input object.
    OverRange = 2, //The sensor connected to the Input is reading a value higher than the normal operating range. If the object is a Binary Input, this is possible when the Binary state is derived from an analog sensor or a binary input equipped with electrical loop supervision circuits.
    UnderRange = 3, //The sensor connected to the Input is reading a value lower than the normal operating range. If the object is a Binary Input, this is possible when the Binary Input is actually a binary state calculated from an analog sensor.
    OpenLoop = 4, //The connection between the defined object and the physical device is providing a value indicating an open circuit condition.
    ShortedLoop = 5, //The connection between the defined object and the physical device is providing a value indicating a short circuit condition.
    NoOutput = 6, //No physical device is connected to the Output object.
    UnreliableOther = 7, //The controller has detected that the present value is unreliable, but none of the other conditions describe the nature of the problem. A generic fault other than those listed above has been detected, e.g., a Binary Input is not cycling as expected.
    ProcessError = 8, //A processing error was encountered.
    MultiStateFault = 9, //The FAULT_STATE, FAULT_LIFE_SAFETY or FAULT_CHARACTERSTRING fault algorithm has evaluated a fault condition.
    ConfigurationError = 10, //The object's properties are not in a consistent state.
    CommunicationFailure = 12, //Proper operation of the object is dependent on communication with a remote sensor or device and communication with the remote sensor or device has been lost.
    MemberFault = 13, //The object's properties are not in a consistent state.The object's properties are not in a consistent state.
    MonitoredObjectFault = 14, //Indicates that the monitored object is in fault.
    Tripped = 15 //Indicates that the monitored object is in fault.
}